export default {"src":"/_next/static/media/info1.e281cb95.gif","height":850,"width":850,"blurWidth":0,"blurHeight":0};